import React from "react";
import { TrashIcon } from "@heroicons/react/24/outline";

export default function CartSummary({ cart, onRemove }) {
    return (
        <div className="w-full">
            <h3 className="font-semibold text-black text-sm mb-3">
                Cart Summary
            </h3>

            <div className="border-t border-gray-200 pt-4">
                <div className="grid grid-cols-12 text-xs text-gray-500 mb-3">
                    <div className="col-span-3 font-medium">Product</div>
                    <div className="col-span-6 font-medium">Descriptions</div>
                    <div className="col-span-2 font-medium text-center">SubTotal</div>
                    <div className="col-span-1 font-medium text-center">Actions</div>
                </div>

                {cart.length === 0 ? (
                    <div className="text-xs text-gray-400 py-6 text-center">
                        No items in cart
                    </div>
                ) : (
                    cart.map((item) => (
                        <div
                            key={item.id}
                            className="grid grid-cols-12 items-start border-t border-gray-200 py-4 text-xs"
                        >
                            <div className="col-span-3">
                                <div className="font-semibold text-black">{item.title}</div>
                                <div className="text-gray-400">Subscription</div>
                            </div>

                            <div className="col-span-6 text-gray-500">
                                <div className="mt-2 text-gray-500">
                                    <span className="font-medium text-black">Duration:</span>{" "}
                                    {item.duration}
                                </div>
                            </div>

                            <div className="col-span-2 text-center font-medium text-black">
                                {item.price}
                            </div>

                            <div className="col-span-1 flex justify-center">
                                <button
                                    onClick={() => onRemove(item.id)}
                                    className="text-gray-400 hover:text-gray-700"
                                >
                                    <TrashIcon className="h-4 w-4" />
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>

            <div className="flex justify-end mt-6">
                <button className="bg-black text-white px-5 py-2 rounded text-xs hover:bg-gray-900 transition-colors">
                    Proceed to checkout
                </button>
            </div>
        </div>
    );
}
